import { render } from "./VueFollowList.vue?vue&type=template&id=3a73b6de&ts=true&lang=pug"
import script from "./VueFollowList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueFollowList.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/public/VueFollowList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a73b6de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a73b6de', __exports__)) {
    api.reload('3a73b6de', __exports__)
  }
  
  module.hot.accept("./VueFollowList.vue?vue&type=template&id=3a73b6de&ts=true&lang=pug", () => {
    api.rerender('3a73b6de', render)
  })

}


export default __exports__